module.exports = __webpack_public_path__ + "static/media/send.140d1b34.png";